/*=========================================================================================
  File Name: moduleSystem.js
  Description: Server Monitoring Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleSystemState.js'
import mutations from './moduleSystemMutations.js'
import actions from './moduleSystemActions.js'
import getters from './moduleSystemGetters.js'

export default {
    isRegistered: false,
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}